import { render, staticRenderFns } from "./commoditySorting.vue?vue&type=template&id=244ce09d&scoped=true"
import script from "./commoditySorting.vue?vue&type=script&lang=js"
export * from "./commoditySorting.vue?vue&type=script&lang=js"
import style0 from "./commoditySorting.vue?vue&type=style&index=0&id=244ce09d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244ce09d",
  null
  
)

export default component.exports